import { render } from "./RpmInputLabel.vue?vue&type=template&id=4c962b14"
import script from "./RpmInputLabel.vue?vue&type=script&lang=js"
export * from "./RpmInputLabel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__